import cronstrue from 'cronstrue';

// Convert minutes to cron expression
export const minutesToCron = (minutes: number | undefined): string => {
  if (!minutes) return '';
  return `*/${minutes} * * * *`;
};

// Convert cron expression to minutes
export const cronToMinutes = (cron: string | undefined): string => {
  if (!cron) return '';
  const match = cron.match(/^\*\/(\d+) \* \* \* \*$/);
  return match ? match[1] : '';
};

// Get human-readable description of cron expression
export const getCronDescription = (cron: string | undefined): string => {
  if (!cron) return '';
  try {
    return cronstrue.toString(cron);
  } catch (e) {
    console.error('Error parsing cron expression:', e);
    return '';
  }
};

// Get human-readable description from minutes
export const getMinutesDescription = (minutes: number | undefined): string => {
  if (!minutes) return '';
  const num = parseInt(minutes.toString(), 10);
  if (isNaN(num)) return '';

  if (num < 60) {
    return `${num} minute${num === 1 ? '' : 's'}`;
  } else if (num === 60) {
    return '1 hour';
  } else if (num < 1440) {
    const hours = num / 60;
    return `${hours} hour${hours === 1 ? '' : 's'}`;
  } else {
    const days = num / 1440;
    return `${days} day${days === 1 ? '' : 's'}`;
  }
};

// Get refresh cadence options with both cron and human-readable values
export const getRefreshCadenceOptions = (): {
  value: string;
  label: string;
}[] => [
  { value: '*/5 * * * *', label: '5 minutes' },
  { value: '*/15 * * * *', label: '15 minutes' },
  { value: '*/30 * * * *', label: '30 minutes' },
  { value: '0 * * * *', label: '1 hour' },
  { value: '0 */2 * * *', label: '2 hours' },
  { value: '0 */4 * * *', label: '4 hours' },
  { value: '0 */8 * * *', label: '8 hours' },
  { value: '0 */12 * * *', label: '12 hours' },
  { value: '0 0 * * *', label: '24 hours' },
];

// Get the simple label for a specific refresh cadence cron string
export const getRefreshCadenceLabel = (
  cronString: string | undefined
): string => {
  const options = getRefreshCadenceOptions();
  const option = options.find((opt) => opt.value === cronString);
  return option ? option.label : cronString || ''; // Return the cron string if no match found
};
